<template>
  <div class="common-ad">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>展会设置</BreadcrumbItem>
          <BreadcrumbItem>注意事项</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">注意事项</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="show = true">
          <span>新增注意事项</span>
        </div>
      </div>
    </div>
    <div class="common-down">
      <template v-if="list && list.length">
        <Table :border="false" :columns="columns1" :data="list" :disabled-hover="false">
          <template slot-scope="{ row }" slot="text">
            <span class="brand">{{row.text}}</span>
          </template>
          <template slot-scope="{ row }" slot="showIndex">{{row.showIndex}}</template>
          <template slot-scope="{ row, index }" slot="inTime">{{row.inTime | moment("YYYY/MM/DD HH:mm")}}</template>
          <template slot-scope="{ row }" slot="action">
            <span style="color: #1890ff;cursor: pointer;" @click="editShow(row)">编辑</span>
            <span style="display: inline-block;padding: 0 5px;">|</span>
            <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
              <span style="color: #f00;cursor: pointer;">删除</span>
            </Poptip>
          </template>
        </Table>
      </template>
      <div class="u-empty" v-else>暂无数据</div>
    </div>

    <tipAdd :show="show" @finish="init" @close="show=false;" />

    <tipEdit v-if="editShowFlag" :show="editShowFlag" :data="editInfo" @close="editShowFlag=false;editInfo={};" @finish="init" />
  </div>
</template>

<script>   
import tipAdd from "../components/tip-add.vue";
import tipEdit from "../components/tip-edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "host-common-tip",
  components: {
    tipAdd,
    tipEdit,
  },
  data () {
    return {
      loading: false,
      list: null,
      editShowFlag: false,
      editInfo: false,
      show: false,
      options: {},
      modelTitle: '',
      columns1: [
        {
          title: "注意事项",
          slot: "text",
          key: "text",
        },
        {
          title: "排序",
          slot: "showIndex",
          key: "showIndex",
          align: "center"
        },
        {
          title: "发布时间",
          slot: "inTime",
          key: "inTime",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ]
    };
  },
  mounted () {
    this.init();
  },
  computed: {
    ...mapGetters({
      exhibition: "hostSetModule/getHostExhibition"
    }),
    exhibitionInfo () {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  methods: {
    ...mapActions({
      getExhibitionPayAttentionByExId: "registerdModule/getExhibitionPayAttentionByExId",
      delExhibitionPayAttention: "registerdModule/delExhibitionPayAttention",
    }),
    init () {
      this.getExhibitionPayAttentionHandle();
    },
    async getExhibitionPayAttentionHandle () {
      let res = await this.getExhibitionPayAttentionByExId(this.exhibitionInfo.id);
      if (res) {
        res.reverse();
        this.list = res;
      }
      console.log('getExhibitionPayAttentionHandle', res);
    },
    async delItem (item) {
      let result = await this.delExhibitionPayAttention(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    editShow (item) { // 编辑
      this.editShowFlag = true;
      this.editInfo = item;
    },
  },
};
</script>

<style lang="scss" scoped>
.common-down {
  padding: 40px;
  margin: 24px;
  background: #fff;
  min-height: 500px;
  min-width: 1000px;
  p {
    font-size: 16px;
  }
}
</style>